import React from 'react';

import './input-select.scss';

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      multiCheckValue: props.defaultValue
    };

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(e) {
    const value = e.target.value;
    let newMultiCheckValue = '';
    const { multiCheckValue } = this.state;
    const valueArray =  multiCheckValue ? multiCheckValue.split(','): [];

    if (this.props.onChange) {
      if (e.target.checked && (!multiCheckValue || valueArray.indexOf(value) === -1) ) {
        newMultiCheckValue = !multiCheckValue 
          ? e.target.value  
          : multiCheckValue + "," + value;
      } else if (!e.target.checked && multiCheckValue && valueArray.indexOf(value) > -1) {
        const temp =  multiCheckValue;
        if ((multiCheckValue.indexOf(value+",")) >-1 ) {
          newMultiCheckValue = temp.replace(value+",", "");
        } else {
          newMultiCheckValue = temp.replace(value, "");
        }
      }

      this.props.onChange({
        target: {
          value: newMultiCheckValue
        }
      });

      this.setState({ 
        multiCheckValue: newMultiCheckValue, 
      });
    }
  }

  render() {
    const options  = this.props.field.field_options;
    const { multiCheckValue } = this.state;
    const valueArray =  multiCheckValue ? multiCheckValue.split(','): [];

    return (
      <div>
      {options.map(option => (
        <div>
          <input
            type="checkbox"
            key={option.id}
            value={option.option_value}
            onChange = {this.handleOnChange}
            checked = {(multiCheckValue && (valueArray.indexOf(option.option_value) >-1)) ? "checked": null}
          />{' '}
          {option.option_value}
        </div>
      ))}
    </div>
    );
  }
}

export default MultiSelect;



// WEBPACK FOOTER //
// ./src/routes/modules/routes/ViewComponent/components/ComponentWrapper/inputs/multi-select.js